import "pixi-filters";
import AppWorks from "slotworks/appworks";
import { FatalErrorCommand } from "slotworks/commands/error/fatal-error-command";
import { AssetConfigSchema } from "slotworks/config/asset-config-schema";
import { ComponentConfigSchema } from "slotworks/config/component-config-schema";
import { GameConfigSchema } from "slotworks/config/game-config-schema";
import { I18NConfigSchema } from "slotworks/config/i18n-config-schema";
import { SoundConfigSchema } from "slotworks/config/sound-config-schema";
import Bet from "slotworks/model/bets/bet-model";
import SettingsModel from "slotworks/model/settings/settings-model";
import SlotDefinition from "slotworks/model/slot-definition";
import CommsManager from "slotworks/server/comms-manager";
import { StateMachineConfig } from "slotworks/state-machine/parser/config/state-machine-config-schema";
import StandardStates from "slotworks/state-machine/standard/standard-states";

export default class SlotWorks {

    public static go(gameConfig: GameConfigSchema,
                     stateConfig: StateMachineConfig,
                     assetConfig: AssetConfigSchema,
                     componentConfig: ComponentConfigSchema,
                     soundConfig: SoundConfigSchema,
                     i18nConfig: I18NConfigSchema,
                     ready: Function) {

        CommsManager.connector.onError((message) => FatalErrorCommand(message));

        SettingsModel.load();

        SlotDefinition.processConfig(gameConfig);
        Bet.processConfig(gameConfig);

        StandardStates.init();

        AppWorks.go(gameConfig, stateConfig, assetConfig, componentConfig, soundConfig, i18nConfig, ready);
    }

    private constructor() { }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/slotworks.ts